import { useQueries, useQuery } from '@tanstack/react-query'

import { PhantomTypeArgument } from '@/shared/gen/_framework/reified'
import { compressSuiType } from '@/shared/gen/_framework/util'
import { CoinInfo, PriceCache } from '@kunalabs-io/kai'

export const tokenPriceQueryKey = (
  tokenX: CoinInfo<PhantomTypeArgument>,
  tokenY: CoinInfo<PhantomTypeArgument>
) =>
  [
    'token-price',
    `${compressSuiType(tokenX.typeName)}-${compressSuiType(tokenY.typeName)}`,
  ] as const

const priceCache = new PriceCache(10)

export const useTokenPrice = <X extends PhantomTypeArgument, Y extends PhantomTypeArgument>(
  tokenX: CoinInfo<X>,
  tokenY: CoinInfo<Y>
) => {
  const { data, isLoading } = useQuery({
    queryKey: tokenPriceQueryKey(tokenX, tokenY),
    queryFn: () => priceCache.get(tokenX, tokenY),
    refetchInterval: 1000 * 60,
    staleTime: 1000 * 60,
  })

  return {
    price: data,
    isLoading,
  }
}

export const useTokenPriceBatch = <X extends PhantomTypeArgument, Y extends PhantomTypeArgument>(
  tokens: CoinInfo<X>[],
  tokenY: CoinInfo<Y>
) => {
  return useQueries({
    queries: tokens.map(token => ({
      queryKey: tokenPriceQueryKey(token, tokenY),
      queryFn: () => priceCache.get(token, tokenY),
      refetchInterval: 1000 * 60,
      staleTime: 1000 * 60,
    })),
  })
}
